exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dashboard-page-wrap[data-v-106c86ed] {\n  /* 至少占满可视区；缩放后内容增高时由 app-main 滚动，避免裁切错位 */\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  min-height: calc(100vh - 118px);\n  height: auto;\n  max-height: none;\n  overflow: visible;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n@media screen and (max-width: 992px) {\n.dashboard-page-wrap[data-v-106c86ed] {\n    min-height: 0;\n}\n}\n", ""]);

// exports
